/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveUserFromWorkspaceResponse } from '../../models/remove-user-from-workspace-response';

export interface RemoveUserFromWorkspace$Params {

/**
 * Workspace ID
 */
  workspaceId: number;

/**
 * User ID
 */
  userId: string;
}

export function removeUserFromWorkspace(http: HttpClient, rootUrl: string, params: RemoveUserFromWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveUserFromWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, removeUserFromWorkspace.PATH, 'delete');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoveUserFromWorkspaceResponse>;
    })
  );
}

removeUserFromWorkspace.PATH = '/workspaces/{workspaceId}/user/{userId}';
